import { motion } from "framer-motion";

export const About = () => (
    <section id="about" data-testid="about-section" className="relative py-20 lg:py-32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 grid lg:grid-cols-12 gap-12">
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7 }}
                className="lg:col-span-5"
            >
                <div className="font-mono text-[11px] tracking-[0.3em] text-bn-blue font-semibold mb-4">ABOUT US</div>
                <h2 data-testid="about-heading" className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl text-white">
                    Five analysts. <span className="text-slate-500">One daily single &amp; one daily double.</span>
                </h2>
            </motion.div>
            <motion.div
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.7, delay: 0.15 }}
                className="lg:col-span-7 space-y-6"
            >
                <p className="text-base lg:text-lg text-slate-300 leading-relaxed">
                    BettingNator brings together professional football analysts dedicated to delivering carefully researched Singles and Doubles every day.
                </p>
                <p className="text-base text-slate-400 leading-relaxed">
                    Our BettingNator tipsters — <span className="text-white font-semibold">Lukas Gruber</span> 🇦🇹, <span className="text-white font-semibold">Felix Schneider</span> 🇩🇪 and <span className="text-white font-semibold">Anders Johansen</span> 🇳🇴 — are responsible for all Singles selections, focusing on individual matches and using detailed research, statistics, current form, team news, tactical analysis and market movement.
                </p>
                <p className="text-base text-slate-400 leading-relaxed">
                    For our Doubles, we work with our Greek tipster collaborators <span className="text-white font-semibold">Nikos Papadopoulos</span> 🇬🇷 and <span className="text-white font-semibold">Georgios Nikolaidis</span> 🇬🇷, who specialise in analysing and selecting the strongest two-match combinations for our daily Doubles.
                </p>
                <p className="text-base text-slate-400 leading-relaxed">
                    Each selection is carefully reviewed before being released, with a clear focus on quality, consistency and professional analysis. We also maintain a transparent record of our selections, including odds and final results.
                </p>
                <p className="text-base lg:text-lg text-white font-semibold leading-relaxed">
                    BettingNator — Professional Singles. Carefully Selected Doubles. One Standard of Quality.
                </p>
            </motion.div>
        </div>
    </section>
);
